"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdatePushTokens = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var getIsExistingToken_1 = require("../utilities/get/getIsExistingToken");
var getFingerPrint_1 = require("../utilities/getFingerPrint");
var envConfigBase_1 = require("../envConfig/envConfigBase");
var createErrorAction_1 = require("../actionCreators/createErrorAction");
var dispatchUpdateUnscopeUser_1 = require("../state/dispatch/dispatchUpdateUnscopeUser");
var clientMeta_1 = require("../utilities/clientMeta");
var description = 'useUpdatePushTokens';
var useUpdatePushTokens = function (_a) {
    var parentDescription = _a.parentDescription;
    var dispatch = (0, react_redux_1.useDispatch)();
    var useDescription = "".concat(parentDescription, " - ").concat(description, " ");
    var _b = (0, react_1.useState)(false), working = _b[0], setWorking = _b[1];
    var currentUnscopeUser = (0, react_redux_2.useSelector)(function (state) {
        return state.currentUnscopeUser;
    });
    var currentUserId = (0, react_redux_2.useSelector)(function (state) {
        return state.currentUserId;
    });
    var submit = (0, react_1.useCallback)(function (_a) { return tslib_1.__awaiter(void 0, [_a], void 0, function (_b) {
        var notificationTokens, isExistingToken, currentFingerPrint_1, existingFingerPrint, newMessagingTokens;
        var _c;
        var token = _b.token, onSuccess = _b.onSuccess;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setWorking(true);
                    notificationTokens = currentUnscopeUser === null || currentUnscopeUser === void 0 ? void 0 : currentUnscopeUser.notificationTokens;
                    isExistingToken = (0, getIsExistingToken_1.getIsExistingToken)({
                        unscopeUser: currentUnscopeUser || undefined,
                        findToken: token,
                    });
                    if (!(token && currentUserId)) return [3 /*break*/, 4];
                    if (!!isExistingToken) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, getFingerPrint_1.getFingerPrint)()];
                case 1:
                    currentFingerPrint_1 = _d.sent();
                    existingFingerPrint = !!(notificationTokens === null || notificationTokens === void 0 ? void 0 : notificationTokens.find(function (notificationToken) {
                        return (typeof notificationToken !== 'string' &&
                            notificationToken.fingerPrint === currentFingerPrint_1);
                    }));
                    newMessagingTokens = void 0;
                    if (existingFingerPrint) {
                        newMessagingTokens = (_c = (notificationTokens || [])) === null || _c === void 0 ? void 0 : _c.map(function (notificationToken) {
                            if (typeof notificationToken !== 'string' &&
                                notificationToken.fingerPrint === currentFingerPrint_1) {
                                return tslib_1.__assign(tslib_1.__assign({}, notificationToken), { token: token, createdMs: Date.now(), appName: (0, envConfigBase_1.envConfigBase)().appName });
                            }
                            return notificationToken;
                        });
                    }
                    else {
                        newMessagingTokens = tslib_1.__spreadArray([
                            {
                                token: token,
                                createdMs: Date.now(),
                                fingerPrint: currentFingerPrint_1,
                                appName: (0, envConfigBase_1.envConfigBase)().appName,
                                platform: clientMeta_1.clientMeta.platform,
                            }
                        ], (notificationTokens || []), true).slice(0, (0, envConfigBase_1.envConfigBase)().maxMessagingTokens);
                    }
                    return [4 /*yield*/, (0, dispatchUpdateUnscopeUser_1.dispatchUpdateUnscopeUser)({
                            userId: currentUserId,
                            dispatch: dispatch,
                            parentDescription: useDescription,
                            values: {
                                notificationTokens: newMessagingTokens,
                            },
                        })];
                case 2:
                    _d.sent();
                    dispatch(
                    // Since user activated notification, its safe to assume the user would want us to ask again
                    {
                        type: 'SET_COOKIE_STORAGE',
                        description: useDescription,
                        values: {
                            dontAskToEnableNotificationMs: 0,
                        },
                    });
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    _d.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    dispatch((0, createErrorAction_1.createErrorAction)({ description: "".concat(useDescription, " - missing data") }));
                    _d.label = 5;
                case 5:
                    setWorking(false);
                    return [2 /*return*/];
            }
        });
    }); }, [currentUserId, dispatch, useDescription, currentUnscopeUser]);
    return { submit: submit, working: working };
};
exports.useUpdatePushTokens = useUpdatePushTokens;
